var _defs, _ellipse, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4171",
    "data-name": "Group 4171",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 63.793,
    height: 63.865,
    viewBox: "0 0 63.793 63.865",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.078,
    y1: 0.036,
    x2: 0.935,
    y2: 0.978,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6541c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.048,
    stopColor: "#6d3ec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.127,
    stopColor: "#8538b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "#ac2ea5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339,
    stopColor: "#e2208f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#f21c89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416,
    stopColor: "#f22068"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477,
    stopColor: "#f32644"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534,
    stopColor: "#f3292b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    stopColor: "#f32c1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#f42d16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661,
    stopColor: "#f43516"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.718,
    stopColor: "#f44d17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#f47419"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#f5aa1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.957,
    stopColor: "#f6e81e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.188,
    y1: 0.129,
    x2: 0.987,
    y2: 0.883,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6541c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#f21c89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.571,
    stopColor: "#f23455"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.682,
    stopColor: "#f34927"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    stopColor: "#f45216"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.764,
    stopColor: "#f46617"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#f59d1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913,
    stopColor: "#f5c61c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.967,
    stopColor: "#f5de1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f6e81e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -12.747,
    y1: -7.468,
    x2: 2.613,
    y2: 1.771,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -4.684,
    y1: -1.786,
    x2: 2.744,
    y2: 1.489,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.022,
    stopColor: "#4f1c89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#691776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    stopColor: "#960f57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    stopColor: "#bb083e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#d4032c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.834,
    stopColor: "#e40021"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.957,
    stopColor: "#ea001e"
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1693",
    "data-name": "Ellipse 1693",
    cx: 30.942,
    cy: 30.942,
    rx: 30.942,
    ry: 30.942,
    transform: "translate(1.117 0.893)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4168",
    "data-name": "Group 4168",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1703",
    "data-name": "Ellipse 1703",
    cx: 25.552,
    cy: 25.552,
    rx: 25.552,
    ry: 25.552,
    transform: "translate(6.373 6.388)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4156",
    "data-name": "Group 4156",
    transform: "translate(9.434 10.396)",
    opacity: 0.78
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4155",
    "data-name": "Group 4155"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4151",
    "data-name": "Group 4151",
    transform: "translate(0 4.28)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4150",
    "data-name": "Group 4150"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13940",
    "data-name": "Path 13940",
    d: "M5112.779,1511.2a1.2,1.2,0,0,1-1.2-1.2,22.5,22.5,0,0,1,7.731-16.97,1.2,1.2,0,1,1,1.573,1.807,20.1,20.1,0,0,0-6.908,15.164A1.2,1.2,0,0,1,5112.779,1511.2Z",
    transform: "translate(-5111.581 -1492.734)",
    fill: "#d780ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4154",
    "data-name": "Group 4154",
    transform: "translate(10.776)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4153",
    "data-name": "Group 4153"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4152",
    "data-name": "Group 4152"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13941",
    "data-name": "Path 13941",
    d: "M5236.676,1447.755a1.2,1.2,0,0,1-.594-2.239,22.424,22.424,0,0,1,4.457-1.93,1.2,1.2,0,1,1,.708,2.289,20,20,0,0,0-3.979,1.724A1.193,1.193,0,0,1,5236.676,1447.755Z",
    transform: "translate(-5235.477 -1443.532)",
    fill: "#d780ff"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4163",
    "data-name": "Group 4163"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4158",
    "data-name": "Group 4158"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4157",
    "data-name": "Group 4157"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13942",
    "data-name": "Path 13942",
    d: "M5035.046,1387.879a31.933,31.933,0,1,1,22.585-54.51,1.2,1.2,0,0,1-1.694,1.694,29.545,29.545,0,1,0,0,41.782,1.2,1.2,0,0,1,1.694,1.694A31.845,31.845,0,0,1,5035.046,1387.879Z",
    transform: "translate(-5003.121 -1324.014)",
    fill: "url(#linear-gradient-2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4160",
    "data-name": "Group 4160",
    transform: "translate(60.808 34.289)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4159",
    "data-name": "Group 4159"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13943",
    "data-name": "Path 13943",
    d: "M5703.421,1723.437a1.2,1.2,0,0,1-1.173-1.445c.187-.89.335-1.8.44-2.7a1.2,1.2,0,0,1,2.379.275c-.113.977-.273,1.96-.475,2.922A1.2,1.2,0,0,1,5703.421,1723.437Z",
    transform: "translate(-5702.222 -1718.228)",
    fill: "url(#linear-gradient-3)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4162",
    "data-name": "Group 4162",
    transform: "translate(57.892 16.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4161",
    "data-name": "Group 4161"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13944",
    "data-name": "Path 13944",
    d: "M5673.4,1526.48a1.2,1.2,0,0,1-1.194-1.116,29.458,29.458,0,0,0-3.368-11.817,1.2,1.2,0,0,1,2.116-1.123,31.847,31.847,0,0,1,3.642,12.777,1.2,1.2,0,0,1-1.113,1.277Z",
    transform: "translate(-5668.701 -1511.788)",
    fill: "url(#linear-gradient-4)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4167",
    "data-name": "Group 4167",
    transform: "translate(17.019 17.585)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4165",
    "data-name": "Group 4165",
    transform: "translate(1.356 1.356)",
    opacity: 0.71
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4164",
    "data-name": "Group 4164"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13945",
    "data-name": "Path 13945",
    d: "M5229.195,1571.431c-1.428,0-2.856.016-4.284,0a18.745,18.745,0,0,1-4.145-.354,7.654,7.654,0,0,1-6.073-6.177,15.55,15.55,0,0,1-.308-3.378q-.028-4.917,0-9.835a14.2,14.2,0,0,1,.467-4.014,7.639,7.639,0,0,1,6.028-5.566,15.5,15.5,0,0,1,3.377-.311q4.929-.028,9.858,0a14.478,14.478,0,0,1,3.883.432,7.634,7.634,0,0,1,5.706,6.107,18.872,18.872,0,0,1,.315,4.013q.026,4.25,0,8.5a18.369,18.369,0,0,1-.347,4.168,7.652,7.652,0,0,1-6.228,6.1,19.256,19.256,0,0,1-3.922.313C5232.081,1571.446,5230.638,1571.431,5229.195,1571.431Zm.009-27.062c0,.015,0,.03,0,.045-1.194,0-2.388-.018-3.581,0a23.029,23.029,0,0,0-4.086.265,5.009,5.009,0,0,0-4.15,3.789,11.051,11.051,0,0,0-.328,2.9c-.026,3.052-.048,6.1-.036,9.156a19.082,19.082,0,0,0,.257,3.747,5.023,5.023,0,0,0,3.816,4.152,10.619,10.619,0,0,0,2.784.319q5.314.023,10.628,0a13.2,13.2,0,0,0,2.319-.218,4.984,4.984,0,0,0,4.194-3.821,11.087,11.087,0,0,0,.321-2.9q.023-5.2,0-10.4a12.125,12.125,0,0,0-.26-2.655,5.023,5.023,0,0,0-2.488-3.455,6.855,6.855,0,0,0-3.181-.784C5233.342,1544.443,5231.272,1544.413,5229.2,1544.369Z",
    transform: "translate(-5214.371 -1541.775)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13946",
    "data-name": "Path 13946",
    d: "M5304.849,1624.624a7.622,7.622,0,1,1-7.618,7.531A7.615,7.615,0,0,1,5304.849,1624.624Zm.008,2.653a4.964,4.964,0,1,0,4.956,4.963A4.976,4.976,0,0,0,5304.856,1627.277Z",
    transform: "translate(-5290.024 -1617.418)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13947",
    "data-name": "Path 13947",
    d: "M5457.17,1604.316a1.778,1.778,0,1,1,1.751-1.818A1.783,1.783,0,0,1,5457.17,1604.316Z",
    transform: "translate(-5434.396 -1595.63)",
    fill: "url(#linear-gradient-5)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4166",
    "data-name": "Group 4166"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13948",
    "data-name": "Path 13948",
    d: "M5213.608,1555.844c-1.428,0-2.856.016-4.284,0a18.738,18.738,0,0,1-4.145-.354,7.653,7.653,0,0,1-6.073-6.177,15.55,15.55,0,0,1-.308-3.378q-.028-4.918,0-9.836a14.2,14.2,0,0,1,.467-4.014,7.638,7.638,0,0,1,6.028-5.565,15.506,15.506,0,0,1,3.378-.311q4.929-.028,9.858,0a14.473,14.473,0,0,1,3.883.432,7.633,7.633,0,0,1,5.705,6.107,18.874,18.874,0,0,1,.315,4.013q.026,4.25,0,8.5a18.342,18.342,0,0,1-.347,4.168,7.652,7.652,0,0,1-6.228,6.1,19.258,19.258,0,0,1-3.922.313C5216.494,1555.859,5215.051,1555.844,5213.608,1555.844Zm.009-27.062c0,.015,0,.03,0,.045-1.193,0-2.388-.018-3.581,0a23.019,23.019,0,0,0-4.087.265,5.009,5.009,0,0,0-4.15,3.789,11.029,11.029,0,0,0-.328,2.9c-.026,3.052-.049,6.1-.036,9.156a19.155,19.155,0,0,0,.257,3.747,5.024,5.024,0,0,0,3.817,4.152,10.617,10.617,0,0,0,2.784.319q5.314.022,10.628,0a13.231,13.231,0,0,0,2.318-.218,4.983,4.983,0,0,0,4.194-3.821,11.107,11.107,0,0,0,.321-2.9q.023-5.2,0-10.4a12.126,12.126,0,0,0-.261-2.656,5.022,5.022,0,0,0-2.488-3.455,6.855,6.855,0,0,0-3.181-.784C5217.756,1528.857,5215.687,1528.826,5213.617,1528.782Z",
    transform: "translate(-5198.784 -1526.188)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13949",
    "data-name": "Path 13949",
    d: "M5289.262,1609.037a7.622,7.622,0,1,1-7.618,7.531A7.615,7.615,0,0,1,5289.262,1609.037Zm.008,2.653a4.964,4.964,0,1,0,4.956,4.963A4.976,4.976,0,0,0,5289.27,1611.69Z",
    transform: "translate(-5274.437 -1601.831)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13950",
    "data-name": "Path 13950",
    d: "M5441.584,1588.73a1.778,1.778,0,1,1,1.751-1.818A1.783,1.783,0,0,1,5441.584,1588.73Z",
    transform: "translate(-5418.81 -1580.044)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.e836e1823d7a6c77dba48054202bfeb4.svg";
export { ForwardRef as ReactComponent };